/**
 * Decides whether the navigation module renders the accessibility label.
 *
 * The country comes from the first two characters of the selected site code
 * (`BR011288`, `FR…`, `SO…`). France owns two prefixes — `FR` and `SO` — so
 * both resolve to true; they are not separate countries.
 */
export const ACCESSIBILITY_LABEL_SITE_PREFIXES = ['FR', 'SO'];

export const shouldShowAccessibilityLabel = (siteCode: string): boolean =>
  ACCESSIBILITY_LABEL_SITE_PREFIXES.includes(siteCode.slice(0, 2).toUpperCase());
